import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {InfiniteScrollDirective} from 'ngx-infinite-scroll';

import { TableComponent } from './table.component';
import { HeaderSortDirective } from './header-sort/header-sort.directive';
import { TableKeyBindDirective } from './keyboard-navigation/table-key-bind.directive';
import { SpinnerModule } from '../spinner/spinner.module';

@NgModule({
    imports: [CommonModule, InfiniteScrollDirective, SpinnerModule],
    exports: [TableComponent, HeaderSortDirective, TableKeyBindDirective],
    declarations: [TableComponent, HeaderSortDirective, TableKeyBindDirective]
})
export class TableModule {}
